// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YYuj","inner":"Footer_inner__3VAxZ"};